module.exports = __webpack_public_path__ + "img/comercio-beneficio-3.96ea6d43.svg";